angular.module('SpidApp')

.filter('deprecated-isoToFrench', function () {
    return function (input) {
        if (!input || input.length === 0) {
            return ''
        }

        var split = input.split('-')
        var yyyy = split[0]
        var mm = split[1]
        var dd = split[2]

        return dd + '/' + mm + '/' + yyyy
    }
})